'use client';

import React, { useEffect } from "react";
import PlanningUpdatesPage from "./PlanningUpdatesPage";

const STORAGE_KEY = "cityscope:planning-updates-design";

const PlanningDesignSwitcher = () => {
  useEffect(() => {
    if (typeof document !== "undefined") {
      delete document.documentElement.dataset.planningUpdatesDesign;
    }
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      void error;
    }

    if (typeof window !== "undefined") {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.delete("design");
      const nextPath = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      if (nextPath !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
        try {
          window.history.replaceState(window.history.state, "", nextPath);
        } catch (error) {
          void error;
        }
      }
    }
  }, []);

  return <PlanningUpdatesPage />;
};

export default PlanningDesignSwitcher;
